import { Users, Target, CheckCircle, Heart } from 'lucide-react';

const AboutUs = () => {
  const values = [
    {
      icon: Target,
      title: 'Our Mission',
      description: 'To provide transparent, unbiased casino reviews that help UK players make informed decisions and find the perfect gaming experience.'
    },
    {
      icon: CheckCircle,
      title: 'Expert Analysis',
      description: 'Our team of gambling industry veterans thoroughly tests each casino, evaluating bonuses, games, security, and customer service.'
    },
    {
      icon: Heart,
      title: 'Player First',
      description: 'We prioritize responsible gambling and player safety above all else. Every recommendation considers player protection and fair play.'
    },
    {
      icon: Users,
      title: 'Trusted Network',
      description: 'We maintain partnerships with licensed, regulated operators that meet the highest standards of the UK Gambling Commission.'
    }
  ];

  return (
    <section className="py-20 px-4 bg-gradient-to-br from-green-50 to-pink-50">
      <div className="container mx-auto">
        <div className="max-w-6xl mx-auto">
          <div className="text-center mb-16">
            <h2 className="text-4xl md:text-5xl font-bold mb-4 bg-gradient-to-r from-green-600 to-pink-600 bg-clip-text text-transparent">
              About Crown Jackpot
            </h2>
            <p className="text-xl text-gray-700 max-w-3xl mx-auto leading-relaxed">
              We are the UK's premier casino aggregator, dedicated to connecting players with the finest online gaming experiences. 
              With years of industry expertise, we've curated a selection of trusted operators that combine exceptional gameplay, 
              generous bonuses, and unwavering commitment to player safety.
            </p>
          </div>

          <div className="grid md:grid-cols-2 gap-8 mb-12">
            <div className="glass-strong p-8 rounded-3xl">
              <div className="h-64 bg-gradient-to-br from-pink-200 to-green-200 rounded-2xl mb-6" style={{ backgroundImage: 'url("/images/derek-lynn-mD1V-eS1Wb4-unsplash.jpg")', backgroundSize: 'cover', backgroundPosition: 'center' }}>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">Why Choose Us</h3>
              <p className="text-gray-700 leading-relaxed">
                At Crown Jackpot, we understand that choosing the right online casino can be overwhelming. That's why we've made 
                it our mission to simplify your search. Our rigorous review process examines every aspect of each operator – from 
                game variety and software providers to withdrawal speeds and customer support quality.
              </p>
            </div>

            <div className="glass-strong p-8 rounded-3xl">
              <div className="h-64 bg-gradient-to-br from-green-200 to-pink-200 rounded-2xl mb-6" style={{ backgroundImage: 'url("/images/eyestetix-studio-UxqoF0LfHB8-unsplash.jpg")', backgroundSize: 'cover', backgroundPosition: 'center' }}>
              </div>
              <h3 className="text-2xl font-bold text-gray-800 mb-4">Our Commitment</h3>
              <p className="text-gray-700 leading-relaxed">
                We believe that online gambling should be entertaining, secure, and responsible. Every casino featured on our 
                platform holds a valid UK Gambling Commission license, ensuring your funds and personal information are protected. 
                We also champion responsible gambling initiatives and provide resources to help players stay in control.
              </p>
            </div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6">
            {values.map((value, index) => {
              const Icon = value.icon;
              return (
                <div key={index} className="glass p-6 rounded-2xl text-center hover:transform hover:scale-105 transition-all duration-300">
                  <div className="inline-flex items-center justify-center w-16 h-16 bg-gradient-to-r from-green-500 to-pink-500 rounded-full mb-4">
                    <Icon className="w-8 h-8 text-white" />
                  </div>
                  <h4 className="text-lg font-bold text-gray-800 mb-3">{value.title}</h4>
                  <p className="text-gray-600 text-sm leading-relaxed">{value.description}</p>
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
};

export default AboutUs;

